import { useState, useEffect } from "react";
import Header from "../../common/layout/header";
import Footer from "../../common/layout/footer";
import Sidebar from "../../common/sidebar";
import RichTextEditor from "../../common/richTextEditor";
import { BaseUrl } from "../../common/config";
import { http } from "../../helper";
import CommonAlert from "../../common/Commonalert";
import ShowAlert from "../../common/Showalert";
import { useTranslation, Trans } from "react-i18next";
import { canAction } from "../../common/permissionhelper";
const MODULE = "manage_promooffers";

const PromoPinsaSettings = () => {
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit;

  const [isChecked, setIsChecked] = useState(false);
  const [pinsaType, setPinsaType] = useState({
    free: true, // default checked
    paid: false,
  });
  const [error, setError] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // auth check
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }

  if (
    JSON.parse(sessionStorage.getItem("authData")) !== "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_promooffers")
  ) {
    window.location.href = "/unauthorized";
  }
  useEffect(() => {
    setIsLoading(true);
    http.get(BaseUrl + "admin/promo-pinsa")
      .then((res) => {
        if (res.data.success && res.data.data.length > 0) {
          const data = res.data.data[0];

          setIsChecked(data.triggerPromo === "1");
          setPinsaType({
            free: data.pinsaFree === "1",
            paid: data.pinsaPaid === "1",
          });
        }
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isReadOnly) return;

    if (isChecked && !pinsaType.free && !pinsaType.paid) {
      setError("Please select at least one Pinsa type.");
      return;
    }

    const payload = {
      triggerPromo: isChecked ? "1" : "0",
      pinsaFree: isChecked ? (pinsaType.free ? "1" : "0") : "1",
      pinsaPaid: isChecked ? (pinsaType.paid ? "1" : "0") : "0",
    };

    setIsLoading(true);

    http
      .post(BaseUrl + "admin/promo-pinsa", payload)
      .then((res) => {
        if (res.data.success) {
          setAlertPopup(true);
          setAlertMessage("Promo Pinsa settings saved successfully!");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });

    setError("");
  };

  return (
    <section className="dashboard-block">
      {alertPopup && (
        <CommonAlert
          title="Alert"
          message={alertMessage}
          onClose={() => setAlertPopup(false)}
        />
      )}

      <Sidebar />

      <div className="dash-left">
        <Header />

        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">Promo Pinsa Email Settings</h1>

            <div className="right-table-outer-wrap">
              {isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
                <div className="form-field form-container-xs">
                  <form className="client-detail-form">
                    {/* Toggle */}
                    <div className="input-field col-1">
                      <label>Trigger Promo Pinsa Email</label>
                      <div className="switch-button">
                        <input
                          type="checkbox"
                          className="checkbox"
                          checked={isChecked}
                          onChange={() => {
                            if (isReadOnly) return;
                            const newValue = !isChecked;
                            setIsChecked(newValue);
                            if (!newValue) {
                              setPinsaType({ free: true, paid: false }); // reset
                            }
                            setError("");
                          }}
                        />
                        <div className="knobs">
                          <span></span>
                        </div>
                        <div className="layer"></div>
                      </div>
                    </div>

                    {/* Radio (show only if toggle ON) */}
                    {isChecked && (
                      <div className="notification-field-set">
                        <div className="input-field col-1">
                            <label>Pinsa Type</label>

                          <div className="check-box">
                                <input
                                    type="checkbox"
                                    id="paidPinsa"
                                    checked={pinsaType.paid}
                                    onChange={() => {
                                    if (isReadOnly) return;
                                    setPinsaType((prev) => ({
                                        ...prev,
                                        paid: !prev.paid,
                                    }));
                                    setError("");
                                    }}
                                />
                                <label htmlFor="paidPinsa">Paid Pinsa</label>
                                </div>

                                <div className="check-box">
                                <input
                                    type="checkbox"
                                    id="freePinsa"
                                    checked={pinsaType.free}
                                    onChange={() => {
                                    if (isReadOnly) return;
                                    setPinsaType((prev) => ({
                                        ...prev,
                                        free: !prev.free,
                                    }));
                                    setError("");
                                    }}
                                />
                                <label htmlFor="freePinsa">Free Pinsa</label>
                                </div>

                          {error && <div className="error-msg">{error}</div>}
                        </div>
                      </div>
                    )}

                    {/* Submit */}
                    {!isReadOnly && (
                      <div className="btnfield">
                        <button onClick={handleSubmit}>Save</button>
                      </div>
                     )}
                  </form>
                </div>
              )}
            </div>
          </div>

          <Footer />
        </section>
      </div>
    </section>
  );
};

export default PromoPinsaSettings;
